const isFungible = (slug: string) => {
	const normalizedSlug = slug?.toLowerCase()
	return (
		normalizedSlug &&
		(normalizedSlug.startsWith('brc20-') ||
			normalizedSlug.startsWith('tap-') ||
			normalizedSlug.startsWith('drc20-') ||
			normalizedSlug.startsWith('bel20-') ||
			normalizedSlug.startsWith('rune-') ||
			normalizedSlug.startsWith('alkane-'))
	)
}

export default isFungible
